var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { attrs: { cols: "12", xl: "5" } },
    [
      _c("base-card", { staticClass: "medication-card" }, [
        _c("div", {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover:title",
              value: _vm.medicationName,
              expression: "medicationName",
              modifiers: { "hover:title": true }
            }
          ],
          staticClass: "medication-color",
          attrs: { title: _vm.medicationName },
          domProps: { innerHTML: _vm._s(_vm.medicationName) }
        }),
        _vm._v(" "),
        _c("div", {
          attrs: { title: _vm.reminderTypeTitle },
          domProps: { innerHTML: _vm._s(_vm.reminderTypeTitle) }
        }),
        _vm._v(" "),
        _vm.tabletsLeft !== null
          ? _c("div", { staticClass: "mt-2" }, [
              _vm._v(_vm._s(_vm.$t("tabletsLeft") + ": " + _vm.tabletsLeft))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "mt-2 notes",
          domProps: { innerHTML: _vm._s(_vm.notes) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-section" },
          [
            _c(
              "base-button",
              {
                attrs: { blue: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("onEdit", _vm.id)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("edit")))]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: { red: "" },
                on: {
                  click: function($event) {
                    _vm.showDeleteDialog = true
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("remove")))]
            ),
            _vm._v(" "),
            _vm.tabletsReminderSent
              ? _c(
                  "base-button",
                  { attrs: { white: "" }, on: { click: _vm.resetTablets } },
                  [_vm._v(_vm._s(_vm.$t("resetTabletsReminder")))]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            _vm.deleteMedication()
          },
          cancelFn: function() {
            _vm.showDeleteDialog = false
          },
          content: _vm.$t("confirmRemoveMedicationReminder")
        },
        model: {
          value: _vm.showDeleteDialog,
          callback: function($$v) {
            _vm.showDeleteDialog = $$v
          },
          expression: "showDeleteDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b72d9d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b72d9d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/medicationReminder/MedicationReminderBlock.vue
// module id = 4089
// module chunks = 7